import React from 'react';
import { t } from '@lingui/macro';
import { FAQs } from 'components/FAQs/FAQs';
import { BaseLayout } from '../components/Layout/BaseLayout/BaseLayout';

export const FAQsPage = () => {
  return (
    <BaseLayout pageTitle={t`FAQs | Introducer Portal`}>
      <FAQs />
    </BaseLayout>
  );
};
